export const FieldEnableRules = [
    {
      form: "general",
      target: "More High Sea Seller",
      dependsOn: ["importGeneralIsHighSeaSale"],
      formula: ({ importGeneralIsHighSeaSale }) => {
        const jobId = localStorage.getItem("jobId");
        const isHighSea = importGeneralIsHighSeaSale === true || importGeneralIsHighSeaSale === "Yes";
        return !!(jobId && isHighSea);
      },
    },
    
  ];
  
  